import classes from './LogoSvgToggle.module.scss';

import Logo from '../../assets/svgs/Halley (Soheil) Logo_Light Mode Typography copy 1.svg';
import Logo_Light from '../../assets/svgs/Halley (Soheil) Logo_Light Mode Typography copy 1 Light.svg';

export default function LogoSvgToggle({ siderToggled }) {
  return (
    <div
      className={`${classes.svgContainer} ${
        siderToggled ? classes.toggled : ''
      }`}
    >
      <img src={Logo} alt="" className={classes.svgDefault} />

      <img src={Logo_Light} alt="" className={classes.svgToggled} />
    </div>
  );
}
